export default "__VITE_ASSET__1$ZZLiPD__"